import { apiV2, errorHandler } from './index';
import {
  API_ERROR,
  FETCH_ALL_TAPPING_POINTS,
  CLEAR_TAPPING_POINTS
} from '../constants/ActionTypes';
import Swal from 'sweetalert2';

export function fetchTappingPoints() {
  return function (dispatch) {
    apiV2.get(`/tapping-points`)
      .then(response => {
        dispatch({
          type: FETCH_ALL_TAPPING_POINTS,
          payload: response.data.objects
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function addEditTappingPoint(tapping_point_json, onSuccess) {
  return function (dispatch) {
    const data = typeof tapping_point_json === 'string' ? JSON.parse(tapping_point_json) : tapping_point_json;
    const request = data.tapping_point_id
      ? apiV2.put(`/tapping-points/${data.tapping_point_id}`, data)
      : apiV2.post('/tapping-points', data);

    request
      .then(response => {
        Swal.fire({
          icon: 'success',
          title: 'Saved!',
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function deleteTappingPoint(tapping_point_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/tapping-points/${tapping_point_id}`)
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Tapping Point Deleted!',
          timer: 1000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR)
      });
  }
}

export function clearTappingPoints() {
  return function (dispatch) {
    dispatch({
      type: CLEAR_TAPPING_POINTS
    });
  };
}
